/**
 * AJAX history plugin
 *
 * based on jquery bbq plugin
 */
var cache = { };

function ajxCache_addBase(position) {
    this.cache[''] = {
        position:position,
        html:$(position).html()
    };
}

function ajxCache_removeItem(url) {
    if (this.cache[url])
        this.cache[url].position = false;
}


$(function () {
    $(window).bind('hashchange', function (e) {
        var params;
        var url = $.param.fragment();
        if (cache[url] && cache[url].position !== false) {
            $(cache[url].position).html(cache[url].html);
        }
        else {
            // Sections - RSI
            if (url.substr(0, 3) == "rsi") {

                var offset = $("#section_data").offset();
                offset.top = offset.top - $("body > header").height() - 60;
                $.scrollTo(offset, {"duration":500});

                //$.scrollTo("#section_data", {"duration":500});



                params = url.split("/");
                $(".loadingPage").show();
                ajax_call({
                    module:"Articles",
                    action:"loadPageDetailed",
                    type:0,
                    args:{
                        "id":params[1],
                    "page":params[3],
                    "section":params[2]
                    }
                }, function (data) {
                    $("#section_data").html(data);
                    $(".loadingPage").fadeOut();

                    cache[url] = {
                        position:"#section_data",
                    html:data
                    };
                }, "html");
            }
            // Search - tags
            else if (url.substr(0, 3) == "sti") {
                //$.scrollTo("#search_data", {"duration":500});

                //var offset = $("#section_data").offset();
                //offset.top = offset.top - $("body > header").height() - 60;
                //$.scrollTo(offset, {"duration":500});

                params = url.split("/");
                //$(".loadingPage").show();
                ajax_call({
                    module:"Search",
                    action:"loadPageFirst",
                    type:0,
                    args:{
                        "id":params[1],
                    "page":params[2]
                    }
                }, function (data) {
                    $("#search_data").html(data);
                    //$(".loadingPage").fadeOut();


                    cache[url] = {
                        position:"#search_data",
                    html:data
                    };
                }, "html");
            }
            // Search - fulltext
            else if (url.substr(0, 3) == "sfi") {
                $.scrollTo("#search_data", {"duration":500});
                params = url.split("/");
                $(".loadingPage").show();
                ajax_call({
                    module:"Search",
                    action:"loadSearchPageFirst",
                    type:0,
                    args:{
                        "pattern":params[1],
                    "page":params[2]
                    }
                }, function (data) {
                    $("#search_data").html(data);
                    $(".loadingPage").fadeOut();

                    cache[url] = {
                        position:"#search_data",
                    html:data
                    };
                }, "html");
            }

            params = url.split("/");
            if (params[0] == "adm_staticPanelsList") {
                $(".loadingPage").show();
                ajax_call({
                    module:"StaticPanelsAdmin",
                    action:"loadPage",
                    type:0,
                    args:{
                        "page":params[1]
                    }
                }, function (data) {
                    $("#StaticPanelsAdmin_data").html(data);
                    $(".loadingPage").fadeOut();

                    cache[url] = {
                        position:"#StaticPanelsAdmin_data",
                    html:data
                    };
                }, "html");
            }
            else if (params[0] == "clanok_stranka") {
                $(".clanok_podstranka").hide();
                $("#clanok_podstranka_" + params[1]).show();

                $(".Articles_chapterListing li").removeClass("selected");
                $(".Articles_chapterListing li:eq(" + (params[1] - 1) + ")").addClass("selected");
            }
            else if (params[0] == "adm_recepty") {
                $(".loadingPage").show();
                ajax_call({
                    module:"RecipesAdmin",
                    action:"loadPage",
                    type:0,
                    args:{
                        "page":params[1]
                    }
                }, function (data) {
                    $("#RecipesAdmin_data").html(data);
                    $(".loadingPage").fadeOut();

                    cache[url] = {
                        position:"#RecipesAdmin_data",
                    html:data
                    };
                }, "html");
            }
            else if (params[0] == "adm_ankety") {
                $(".loadingPage").show();
                ajax_call({
                    module:"SurveyAdmin",
                    action:"loadPage",
                    type:0,
                    args:{
                        "page":params[1]
                    }
                }, function (data) {
                    $("#SurveyAdmin_data").html(data);
                    $(".loadingPage").fadeOut();

                    cache[url] = {
                        position:"#SurveyAdmin_data",
                    html:data
                    };
                }, "html");
            }
            else if (params[0] == "adm_users") {
                $(".loadingPage").show();
                ajax_call({
                    module:"UserAdmin",
                    action:"loadPage",
                    type:1,
                    args:{
                        "page":params[2],
                    "filter":params[1]
                    }
                }, function (data) {
                    $("#UserAdmin_data").html(data);
                    $(".loadingPage").fadeOut();

                    cache[url] = {
                        position:"#UserAdmin_data",
                    html:data
                    };
                }, "html");
            }
            else if (params[0] == "najcitanejsie") {
                $.scrollTo("#articles_data", {"duration":500});
                $(".loadingPage").show();
                ajax_call({
                    module:"Articles",
                    action:"top_loadPage",
                    type:0,
                    args:{
                        "page":params[1]
                    }
                }, function (data) {
                    $("#articles_data").html(data);
                    $(".loadingPage").fadeOut();

                    cache[url] = {
                        position:"#articles_data",
                    html:data
                    };
                }, "html");
            }
            else if (params[0] == "najzobrazovanejsie") {
                $.scrollTo("#articles_data", {"duration":500});
                $(".loadingPage").show();
                ajax_call({
                    module:"Articles",
                    action:"topAgregate_loadPage",
                    type:0,
                    args:{
                        "page":params[2],
                    "time":params[1]
                    }
                }, function (data) {
                    $("#articles_data").html(data);
                    $(".loadingPage").fadeOut();

                    cache[url] = {
                        position:"#articles_data",
                    html:data
                    };
                }, "html");
            }
            else if (params[0] == "najnovsie") {
                //$.scrollTo("#articles_data", {"duration":500});

                var offset = $(".articles_block").offset();
                offset.top = offset.top - $("body > header").height() - 60;
                $.scrollTo(offset, {"duration":500});


                $(".loadingPage").show();
                ajax_call({
                    module:"Articles",
                    action:"newest_loadPage",
                    type:0,
                    args:{
                        "page":params[1]
                    }
                }, function (data) {
                    $("#articles_data").html(data);
                    $(".loadingPage").fadeOut();

                    cache[url] = {
                        position:"#articles_data",
                    html:data
                    };
                }, "html");
            }
            else if (params[0] == "fotografia-dna" || params[0] == "dniobjektivom" || params[0] == "fotogalerie") {
                $(".loadingPage").show();
                ajax_call({
                    module:"Gallery",
                    action:"loadListOfDay",
                    type:0,
                    args:{
                        "page":params[2],
                    "type":params[0]
                    }
                }, function (data) {
                    $(".content").html(data);
                    $(".loadingPage").fadeOut();

                    cache[url] = {
                        position:".content",
                    html:data
                    };
                }, "html");
            }
            else if (params[0] == "ankety") {
                $.scrollTo("#survey_data", {"duration":500});
                $(".loadingPage").show();
                ajax_call({
                    module:"Survey",
                    action:"loadPage",
                    type:0,
                    args:{
                        "page":params[1]
                    }
                }, function (data) {
                    $("#survey_data").html(data);
                    $(".loadingPage").fadeOut();

                    cache[url] = {
                        position:"#survey_data",
                    html:data
                    };
                }, "html");
            }
            else if (params[0] == "sutaze") {
                $.scrollTo("#contests_data", {"duration":500});
                $(".loadingPage").show();
                ajax_call({
                    module:"Contests",
                    action:"loadPage",
                    type:0,
                    args:{
                        "page":params[1]
                    }
                }, function (data) {
                    $("#contests_data").html(data);
                    $(".loadingPage").fadeOut();

                    cache[url] = {
                        position:"#contests_data",
                    html:data
                    };
                }, "html");
            }
            else if (params[0] == "diskusia") {
                $(".loadingPage").show();
                ajax_call({
                    module:"Discussions",
                    action:"loadPage",
                    type:0,
                    args:{
                        "type":params[1],
                    "id":params[2],
                    "page":params[3]
                    }
                }, function (data) {
                    $("#discussion_holder").html(data);
                    $(".loadingPage").fadeOut();

                    cache[url] = {
                        position:"#discussion_holder",
                    html:data
                    };
                    if (params[3] == "1")
                    ajxCache_addBase("#discussion_holder");
                }, "html");
            }
            else if (params[0] == "recepty") {
                $.scrollTo("#Recipes_data", {"duration":500});
                $(".loadingPage").show();
                ajax_call({
                    module:"Recipes",
                    action:"loadPage",
                    type:0,
                    args:{
                        "section":params[1],
                    "page":params[2]
                    }
                }, function (data) {
                    $("#Recipes_data").html(data);
                    $(".loadingPage").fadeOut();

                    cache[url] = {
                        position:"#Recipes_data",
                    html:data
                    };
                }, "html");
            }
            else if (params[1] == 'fotodennik' || params[0] == 'fotodennik') {
                if (params[1] == 'stranka') {
                    ajax_call({
                        module:'Gallery',
                        action:'loadList',
                        type:0,
                        args:{
                            page:params[2]
                        }
                    }, function (data) {
                        $('div.fotodennik-listing').html(data);
                    });
                }
                else if (params[2] == 'fotografia') {
                    $.fn.MalinaGallery({method:'changePhoto', photo_id:params[3]});
                }
                else if (params[2] == 'slide') {
                    $.fn.MalinaGallery({method:'changeSlidePosition', slide_position:params[3]});
                }
            }
            else if (params[0] == 'scroll'){
                $('html, body').animate({scrollTop: $("#"+params[1]).offset().top - 60}, 2000);
            } 
        }
    });

    // Since the event is only triggered when the hash changes, we need to trigger
    // the event now, to handle the hash the page may have loaded with.
    $(window).trigger('hashchange');
});
